import { render, staticRenderFns } from "./GroupNode.vue?vue&type=template&id=6fa54c17&scoped=true&"
import script from "./GroupNode.vue?vue&type=script&lang=js&"
export * from "./GroupNode.vue?vue&type=script&lang=js&"
import style0 from "./GroupNode.vue?vue&type=style&index=0&id=6fa54c17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa54c17",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
